<template>
  <div
    class="row"
    style="
      padding-top: 15%;
      max-width: 1000px;
      margin-left: auto;
      margin-right: auto;
    "
  >
    <div class="col-md-6" style="padding: 60px;">
      <h3>{{ $t('ssoError.title') }}</h3>
      <br />
      <p>{{ $t('ssoError.description') }}</p>
      <br />
      <img width="100" src="../../../assets/logo-indecx.png" />
    </div>

    <div class="col-md-6">
      <svg
        width="388"
        height="436"
        viewBox="0 0 388 436"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_1762_74618)">
          <path
            d="M219.96 335.945C312.766 335.945 388 260.741 388 167.973C388 75.2039 312.766 0 219.96 0C127.154 0 51.9196 75.2039 51.9196 167.973C51.9196 260.741 127.154 335.945 219.96 335.945Z"
            fill="#F2F2F2"
          />
          <path
            d="M329.771 75.1171H21.9448C21.2847 75.103 20.7611 74.5566 20.7752 73.8968C20.7889 73.2569 21.3046 72.7413 21.9448 72.7276H329.771C330.431 72.7418 330.955 73.2881 330.941 73.9479C330.927 74.5879 330.412 75.1034 329.771 75.1171Z"
            fill="#CACACA"
          />
          <path
            d="M224.865 115.38H139.769C133.378 115.38 128.196 120.56 128.196 126.949V126.949C128.196 133.338 133.378 138.517 139.769 138.517H224.865C231.256 138.517 236.438 133.338 236.438 126.949C236.438 120.56 231.256 115.38 224.865 115.38Z"
            fill="white"
          />
          <path
            d="M84.7974 161.654H279.837C286.229 161.654 291.41 166.833 291.41 173.222C291.41 179.612 286.229 184.791 279.837 184.791H84.7974C78.4058 184.791 73.2244 179.612 73.2244 173.222C73.2244 166.833 78.4058 161.654 84.7974 161.654Z"
            fill="white"
          />
          <path
            d="M84.7974 207.928H279.837C286.229 207.928 291.41 213.107 291.41 219.496C291.41 225.885 286.229 231.065 279.837 231.065H84.7974C78.4058 231.065 73.2244 225.885 73.2244 219.496C73.2244 213.107 78.4058 207.928 84.7974 207.928Z"
            fill="white"
          />
          <path
            d="M60.6274 434.983L60.1684 434.938C44.5944 433.332 30.5156 424.959 21.6723 412.044C19.25 408.446 17.2907 404.557 15.8405 400.469L15.7011 400.079L16.1138 400.045C21.0405 399.649 26.1018 398.813 28.3502 398.416L13.8519 393.505L13.7623 393.075C12.9027 389.039 14.5867 384.885 18.0152 382.586C21.453 380.176 26.0119 380.099 29.5293 382.391C31.1078 383.399 32.7589 384.397 34.3554 385.363C39.842 388.68 45.5154 392.11 49.769 396.804C56.2191 404.064 59.0463 413.846 57.4631 423.426L60.6274 434.983Z"
            fill="#F2F2F2"
          />
          <path
            d="M113.328 427.775L120.473 427.775L123.873 400.223L113.326 400.224L113.328 427.775Z"
            fill="#A0616A"
          />
          <path
            d="M113.076 435.227L135.05 435.226V434.948C135.05 430.226 131.22 426.399 126.497 426.399H126.496L122.483 423.355L114.994 426.399L113.076 426.399L113.076 435.227Z"
            fill="#2F2E41"
          />
          <path
            d="M56.0627 407.992L61.7781 412.278L81.0386 392.279L72.6021 385.953L56.0627 407.992Z"
            fill="#A0616A"
          />
          <path
            d="M51.3876 413.801L68.965 426.982L69.1318 426.76C71.9661 422.983 71.2012 417.624 67.423 414.791L67.4226 414.79L66.0394 409.948L58.2213 407.89L56.6869 406.74L51.3876 413.801H51.3876Z"
            fill="#2F2E41"
          />
          <path
            d="M79.8156 298.484C79.8156 298.484 80.2101 309.24 80.7076 317.865C80.7892 319.28 77.4737 320.817 77.5595 322.356C77.6165 323.377 78.2397 324.369 78.2976 325.434C78.3587 326.557 77.4983 327.552 77.5595 328.714C77.6194 329.849 78.601 331.151 78.6602 332.313C79.2974 344.818 81.6073 359.788 79.2943 363.973C78.1544 366.035 63.6246 394.607 63.6246 394.607C63.6246 394.607 71.7201 406.746 74.0331 402.7C77.0881 397.356 100.633 372.354 100.633 367.579C100.633 362.811 106.08 327.072 106.08 327.072L109.878 348.222L111.619 352.412L111.072 354.872L112.197 358.192L112.258 361.478L113.354 367.579C113.354 367.579 110.058 415.115 111.914 416.439C113.776 417.769 122.791 420.156 123.855 417.769C124.913 415.381 131.801 368.157 131.801 368.157C131.801 368.157 132.911 346.517 134.114 326.402C134.183 325.234 135.005 323.824 135.068 322.673C135.143 321.338 134.623 319.604 134.692 318.309C134.767 316.824 135.427 315.778 135.49 314.356C135.982 303.368 133.223 289.987 132.344 288.669C129.689 284.692 127.301 281.513 127.301 281.513C127.301 281.513 91.5527 269.772 82 281.703L79.8156 298.484L79.8156 298.484Z"
            fill="#2F2E41"
          />
          <path
            d="M115.47 187.881L101.298 185.047L94.685 194.019C82.3449 206.148 82.159 216.852 84.3619 234.011V258.093L82.7675 274.237C82.7675 274.237 77.1233 286.038 82.9448 288.786C88.7663 291.533 127.005 291.299 130.656 290.202C134.306 289.105 131.142 287.759 130.183 282.647C128.382 273.045 129.587 277.677 129.711 274.62C131.488 230.766 127.349 212.762 126.929 208.03L119.721 194.963L115.47 187.881Z"
            fill="#3F3D56"
          />
          <path
            d="M190.163 223.239C188.686 226.036 185.22 227.107 182.421 225.631C182.123 225.473 181.839 225.29 181.573 225.083L150.968 244.507L151.056 233.931L180.787 216.686C182.904 214.312 186.546 214.104 188.92 216.221C190.907 217.992 191.421 220.894 190.163 223.239Z"
            fill="#A0616A"
          />
          <path
            d="M104.281 200.128L100.797 199.759C97.5771 199.426 94.4183 200.804 92.4742 203.391C91.7296 204.372 91.1948 205.495 90.9031 206.692L90.901 206.701C90.027 210.302 91.3978 214.076 94.3796 216.278L106.414 225.146C114.859 236.553 130.731 244.121 149.349 250.27L178.288 232.304L168.052 219.912L148.203 230.546L118.698 207.715L118.681 207.701L107.451 200.469L104.281 200.128L104.281 200.128Z"
            fill="#3F3D56"
          />
          <path
            d="M110.682 180.924C119.809 180.924 127.208 173.528 127.208 164.405C127.208 155.282 119.809 147.886 110.682 147.886C101.554 147.886 94.1555 155.282 94.1555 164.405C94.1555 173.528 101.554 180.924 110.682 180.924Z"
            fill="#A0616A"
          />
          <path
            d="M111.063 180.928C110.93 180.932 110.796 180.935 110.663 180.939C110.606 181.087 110.544 181.234 110.473 181.378L111.063 180.928V180.928Z"
            fill="#2F2E41"
          />
          <path
            d="M115.599 164.863C115.625 165.026 115.664 165.186 115.717 165.342C115.695 165.179 115.656 165.018 115.599 164.863Z"
            fill="#2F2E41"
          />
          <path
            d="M127.419 148.592C126.738 150.704 126.131 148.026 123.894 148.507C121.202 149.087 118.069 148.888 115.865 147.238C112.58 144.829 108.324 144.181 104.47 145.502C100.698 146.836 94.3789 147.777 93.396 151.654C93.0544 153.001 92.9187 154.464 92.0906 155.581C91.3666 156.557 90.2239 157.114 89.2683 157.866C86.0416 160.403 88.5078 167.613 90.0349 171.423C91.5621 175.232 95.0652 178.008 98.9167 179.429C102.643 180.804 106.688 181.047 110.663 180.939C111.355 179.146 111.056 177.076 110.485 175.218C109.868 173.206 108.953 171.264 108.695 169.176C108.437 167.088 109.004 164.715 110.756 163.548C112.366 162.476 114.986 163.129 115.599 164.863C115.241 162.695 117.438 160.597 119.704 160.228C122.136 159.832 124.568 160.71 126.994 161.147C129.419 161.584 128.558 151.377 127.419 148.592Z"
            fill="#2F2E41"
          />
          <path
            d="M219.845 191.731C221.385 173.124 207.544 156.792 188.929 155.252C170.315 153.712 153.976 167.548 152.435 186.155C150.895 204.762 164.736 221.094 183.351 222.634C201.965 224.174 218.304 210.338 219.845 191.731Z"
            fill="#E1513D"
          />
          <path
            d="M195.024 174.857L186.14 183.737L177.256 174.857C175.818 173.42 173.486 173.42 172.048 174.857C170.61 176.295 170.61 178.625 172.048 180.063L180.932 188.943L172.048 197.823C170.612 199.262 170.614 201.593 172.053 203.029C173.491 204.463 175.819 204.463 177.256 203.029L186.14 194.149L195.024 203.029C196.463 204.465 198.795 204.463 200.231 203.024C201.666 201.587 201.666 199.26 200.231 197.823L191.348 188.943L200.231 180.063C201.67 178.625 201.67 176.295 200.231 174.857C198.793 173.42 196.462 173.42 195.024 174.857Z"
            fill="white"
          />
          <path
            d="M172.813 160.529C173.81 163.531 172.183 166.772 169.18 167.769C168.86 167.875 168.531 167.953 168.197 168.001L161.032 203.525L153.458 196.139L161.591 162.755C161.343 159.584 163.714 156.814 166.886 156.567C169.54 156.36 171.99 157.998 172.813 160.529Z"
            fill="#A0616A"
          />
          <path
            d="M96.6729 206.477L93.9943 208.735C91.5245 210.826 90.3326 214.059 90.8541 217.252C91.0469 218.468 91.4878 219.632 92.1494 220.671L92.1549 220.679C94.1494 223.802 97.8227 225.426 101.476 224.799L116.21 222.259C130.292 224.064 146.743 217.855 164.071 208.682L171.136 175.37L155.104 174.174L149.039 195.854L112.13 201.33L112.109 201.333L99.1135 204.426L96.6729 206.477L96.6729 206.477Z"
            fill="#3F3D56"
          />
          <path
            d="M180.568 435.797L0.785182 436C0.350137 435.999 -0.00140493 435.645 4.22169e-06 435.21C0.00140015 434.777 0.352115 434.427 0.785182 434.425L180.568 434.222C181.003 434.223 181.355 434.577 181.354 435.012C181.352 435.445 181.001 435.795 180.568 435.797Z"
            fill="#CACACA"
          />
          <path
            d="M37.5622 59.983C40.6521 59.983 43.1569 57.4234 43.1569 54.266C43.1569 51.1085 40.6521 48.5489 37.5622 48.5489C34.4724 48.5489 31.9675 51.1085 31.9675 54.266C31.9675 57.4234 34.4724 59.983 37.5622 59.983Z"
            fill="#3F3D56"
          />
          <path
            d="M56.8894 59.983C59.9792 59.983 62.4841 57.4234 62.4841 54.266C62.4841 51.1085 59.9792 48.5489 56.8894 48.5489C53.7995 48.5489 51.2947 51.1085 51.2947 54.266C51.2947 57.4234 53.7995 59.983 56.8894 59.983Z"
            fill="#3F3D56"
          />
          <path
            d="M76.2164 59.983C79.3063 59.983 81.8111 57.4234 81.8111 54.266C81.8111 51.1085 79.3063 48.5489 76.2164 48.5489C73.1265 48.5489 70.6217 51.1085 70.6217 54.266C70.6217 57.4234 73.1265 59.983 76.2164 59.983Z"
            fill="#3F3D56"
          />
          <path
            d="M98.2545 58.7846C98.0827 58.7846 97.9111 58.718 97.7816 58.5857L94.0066 54.7282C93.755 54.4712 93.755 54.0605 94.0066 53.8034L97.7816 49.9463C98.0378 49.6854 98.4571 49.6812 98.7171 49.936C98.9784 50.1914 98.983 50.6102 98.7274 50.8711L95.405 54.2658L98.7274 57.6609C98.9829 57.9218 98.9784 58.3406 98.7171 58.596C98.5885 58.7219 98.4215 58.7846 98.2545 58.7846Z"
            fill="#3F3D56"
          />
          <path
            d="M104.598 58.7846C104.431 58.7846 104.264 58.7219 104.135 58.596C103.874 58.3406 103.869 57.9221 104.125 57.6608L107.447 54.2658L104.125 50.8711C103.869 50.6102 103.874 50.1914 104.135 49.936C104.396 49.6802 104.815 49.6851 105.071 49.9463L108.845 53.8034C109.097 54.0605 109.097 54.4712 108.845 54.7282L105.071 58.5856C104.941 58.718 104.77 58.7846 104.598 58.7846Z"
            fill="#3F3D56"
          />
          <path
            d="M302.085 49.2108H295.065C294.265 49.2108 293.617 49.8589 293.617 50.6591V57.6822C293.617 58.4824 294.265 59.1304 295.065 59.1304H302.085C302.885 59.1304 303.54 58.4824 303.54 57.6822V50.6591C303.54 49.8589 302.885 49.2108 302.085 49.2108Z"
            fill="#3F3D56"
          />
          <path
            d="M284.884 49.2108H277.865C277.064 49.2108 276.416 49.8589 276.416 50.6591V57.6822C276.416 58.4824 277.064 59.1304 277.865 59.1304H284.884C285.684 59.1304 286.339 58.4824 286.339 57.6822V50.6591C286.339 49.8589 285.684 49.2108 284.884 49.2108Z"
            fill="#3F3D56"
          />
          <path
            d="M318.293 49.5415H311.274C310.474 49.5415 309.825 50.1895 309.825 50.9897V58.0128C309.825 58.813 310.474 59.4611 311.274 59.4611H318.293C319.094 59.4611 319.749 58.813 319.749 58.0128V50.9897C319.749 50.1895 319.094 49.5415 318.293 49.5415Z"
            fill="#3F3D56"
          />
          <path
            d="M212.493 52.2131H156.385C155.406 52.2131 154.618 53.0067 154.618 53.9789C154.618 54.951 155.406 55.7445 156.385 55.7445H212.493C213.466 55.7445 214.259 54.951 214.259 53.9789C214.259 53.0068 213.466 52.2131 212.493 52.2131Z"
            fill="#3F3D56"
          />
        </g>
        <defs>
          <clipPath id="clip0_1762_74618">
            <rect width="388" height="436" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SSOError',
};
</script>



// WEBPACK FOOTER //
// src/components/pages/sso-error/index.vue